import './FilterTag.scss';

import { DynamicFilter } from '@sonar-software/sonar-ts-types';
import React from 'react';
import { Tag } from 'antd';
import { UpdateQueryParams } from '@hooks';

function getFilterLabel(value: string): string {
	return `${value}:`;
}

export interface FilterTagProps {
	clearValue?: unknown;
	id: string;
	format: string;
	label: string;
	update: UpdateQueryParams<DynamicFilter>;
	value: string | null | undefined;
}

export const FilterTag: React.FC<FilterTagProps> = ({ clearValue = null, id, format, label, update, value }) => {
	if (!value) {
		return null;
	}

	return (
		<Tag
			className='data-dictionary-filter-tag'
			closable
			onClose={ () => {
				update({
					[ id ]: {
						format,
						value: clearValue
					}
				});
			} }>
			<span className='filter-label'>{ getFilterLabel(label) }</span>
			<span className='filter-value'>{ value }</span>
		</Tag>
	);
};
